function applySwatchLogic(container) {
  const swatchWrapper = container.querySelector(".product-swatches-wrapper");
  const swatches = swatchWrapper?.querySelectorAll(".product-swatch");
  const plusIcon = container.querySelector(".swatch-plus");

  if (!swatchWrapper || !swatches?.length) return;

  const isMobile = window.innerWidth < 768;
  const limit = isMobile ? 5 : 7;

  if (swatches.length > limit) {
    swatches.forEach((swatch, index) => {
      if (index >= limit) {
        swatch.classList.add("swatch--hidden");
      }
    });
    plusIcon?.classList.add("visible");
  } else {
    plusIcon?.remove();
  }
}

function initSwatches() {
  const productSwatchesList = document.querySelectorAll(".product-swatches");
  productSwatchesList.forEach(applySwatchLogic);
}

document.addEventListener("DOMContentLoaded", initSwatches);

const observer = new MutationObserver(() => {
  initSwatches();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
